import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="policy-page-container">
      <div className="return-link-container return-link-top">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>
      <h1>Privacy Policy for The Icing Calculator</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to The Icing Calculator. We are committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, disclose, and safeguard your
          information when you visit our website and use our services.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <p>
          We may collect information about you in a variety of ways. The information
          we may collect on the Site includes:
        </p>
        <ul>
          <li>
            <strong>Basic Calculator:</strong> We do not track or store any personal data or calculations you perform using the Basic Calculator version of The Icing Calculator. All calculations are performed client-side and are not transmitted to our servers.
          </li>
          <li>
            <strong>Pro Calculator:</strong> If you choose to use the Pro Calculator, you will be required to log in using your Google account or email address. We will collect and store your email address and associate it with your account. Project data you save using the Pro version of The Icing Calculator (such as cookie names, dimensions, colors, and order quantities) is stored on our secure servers to allow you to access your projects across devices. Payment information for Pro subscriptions is handled by Stripe, and we do not store your credit card details.
          </li>
          <li>
            <strong>Affiliate Links:</strong> We may include affiliate links (e.g., to Amazon). We do not track whether you click on these links or what you purchase.
          </li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <p>
          Having accurate information permits us to provide you with a smooth, efficient,
          and customized experience. Specifically, we may use information collected
          about you via the Site to:
        </p>
        <ul>
          <li>Create and manage your account for The Icing Calculator Pro.</li>
          <li>Provide you with customer support.</li>
          <li>Email you regarding your account or order.</li>
          <li>Process payments and refunds (via Stripe).</li>
        </ul>
      </section>

      <section>
        <h2>Disclosure of Your Information</h2>
        <p>
          We may share information we have collected about you in certain situations.
          Your information may be disclosed as follows:
        </p>
        <ul>
          <li>
            <strong>By Law or to Protect Rights:</strong> If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.
          </li>
          <li>
            <strong>Third-Party Service Providers:</strong> We may share your information with third parties that perform services for us or on our behalf, including payment processing (Stripe), data analysis, email delivery, hosting services, customer service, and marketing assistance.
          </li>
        </ul>
      </section>

      <section>
        <h2>Security of Your Information</h2>
        <p>
          We use administrative, technical, and physical security measures to help
          protect your personal information. While we have taken reasonable steps to
          secure the personal information you provide to us, please be aware that
          despite our efforts, no security measures are perfect or impenetrable, and
          no method of data transmission can be guaranteed against any interception or
          other type of misuse.
        </p>
      </section>

      <section>
        <h2>Policy for Children</h2>
        <p>
          We do not knowingly solicit information from or market to children under the
          age of 13. If you become aware of any data we have collected from children
          under age 13, please contact us using the contact information provided below.
        </p>
      </section>

      <section>
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time in order to reflect, for
          example, changes to our practices or for other operational, legal, or
          regulatory reasons. We will notify you of any changes by posting the new
          Privacy Policy on this page and updating the “Last updated” date.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:
          <br />
          Email: <a href="mailto:support@theicingcalculator.com">support@theicingcalculator.com</a>
        </p>
      </section>
      <div className="return-link-container return-link-bottom">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
